// extracted by mini-css-extract-plugin
export var container = "_ql-0";
export var dotAnimation = "_ql-2";
export var dotsLoading = "_ql-1";